/**
 * API client for user experience feedback submission.
 *
 * @module feedbackApi
 */

import { apiPost } from '@/lib/apiUtils';

export interface FeedbackSubmitPayload {
  readonly overallRating: number;
  readonly usageFrequency: string;
  readonly goalSupportRating: number;
  readonly usedAreas: readonly string[];
  readonly primaryArea: string;
  readonly deviceContext: string;
  readonly likedMost: string;
  readonly improvementAreas: readonly string[];
  readonly experienceDetails: string;
  readonly suggestions: string;
  readonly contactConsent: boolean;
  readonly contactEmail: string;
}

export interface FeedbackSubmitResponse {
  readonly message: string;
  readonly feedbackId: number;
}

/**
 * Submit UX feedback. Returns null on error (toast handled by api layer).
 */
export async function submitFeedback(
  payload: FeedbackSubmitPayload,
): Promise<FeedbackSubmitResponse | null> {
  return apiPost<FeedbackSubmitResponse>('/feedback', payload, {
    errorMessage: 'Failed to submit feedback',
    context: 'submitFeedback',
  });
}
